import LeadTablePage from "components/JCL/LeadTablePage";
export default function Leads() { return <LeadTablePage mine={false} />; }
